<template>
<el-loading-wrapper
  tag="div"
  style="min-height: 100px;"
  class="notepad"
  :loading="loading"
  loading-text="Loading...">

    <notepad-header
      class="notepad-header"
      show-back-button
      @back-button-click="handleClose"
    >
      <template #notepad-header>
        <slot
          name="notepad-header"
        />
      </template>
    </notepad-header>

    <note-composer
      v-if="!loading && currentNote"
      class="notepad-body"
      @save-note-click="onSaveNoteClick"
      @cancel="handleClose"
      :reference="reference"
      :noteData="currentNote"
      :custom-data-function="customDataFunction"
      :custom-creation-form="customCreationForm"
    >
      <template #creation-form="props">
        <slot
          name="creation-form"
          v-bind="props"
        />
      </template>
    </note-composer>
</el-loading-wrapper>
</template>

<style lang="scss">
@import "./_notepad.scss";
</style>

<script>
import {mapGetters, mapActions} from 'vuex'
import notesActions from '#/notes/store/actionTypes'
import NoteComposer from '#/notes/components/NoteComposer'
import NotepadHeader from '#/notes/components/NotepadHeader'

export default {
  name: 'NotepadEdit',
  data () {
    return {
      loading: false
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    customCreationForm: {
      type: Object,
      required: true
    },
    customDataFunction: {
      type: Function,
      required: true
    },
    reference: {
      type: Object,
      required: true
    }
  },
  components: {
    NoteComposer,
    NotepadHeader
  },
  computed: {
    ...mapGetters('notes', [
      'currentNote'
    ])
  },
  watch: {
    'id': {
      async handler (id) {
        this.loading = true
        try {
          await this.fetchNoteById(id)
          this.loading = false
          this.$emit('note-edit-loaded', {note: this.currentNote})
        } catch (error) {
          this.$message.error(error.message)
          this.handleClose()
          return
        }
      },
      immediate: true
    }
  },
  destroyed () {
    this.handleClose()
  },
  methods: {
    ...mapActions({
      fetchNoteById: notesActions.FETCH_NOTE_BY_ID,
      addNote: notesActions.ADD_NOTE
    }),
    handleClose () {
      this.$emit('close')
    },
    async onSaveNoteClick (note) {
      try {
        await this.addNote(note)
        this.$message.success('Note saved successfully!')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.handleClose()
      }
    }
  }
}
</script>
